import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

export function useCollaborations(campaignId: string) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    data = {},
    error,
    isLoading
  } = useQuery({
    queryKey: 'client-campaign-collaborations',
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/campaign/${campaignId}/collaborations`,
        token
      }).then((response: Api.Client.Collaboration[] | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    queryData: { id: campaignId, token },
    enabled: !!token && !!campaignId
  });

  return {
    isLoading,
    error,
    data
  };
}
